import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import onboardIcon from "../../assets/add_employee.png";
import adminIcon from "../../assets/admin.png";
import employeeIcon from "../../assets/employee.png";
import resetPwdIcon from "../../assets/reset-password.png";
import notificationIcon from "../../assets/notification.png";

function SuperadminDashboard() {
  const superadminData = useSelector(
    (state) => state.superadmin?.superadminData
  );

  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuperadmin !== undefined && isSuperadmin === false) {
      navigate("/superadmin/signin");
    }
  }, [isSuperadmin]);

  const optionArray = [
    {
      icon: adminIcon,
      title: "Admins",
      link: "/superadmin/admins/add",
    },
    {
      icon: onboardIcon,
      title: "Onboarding Employee",
      link: "/superadmin/employees/onboarding",
    },
    {
      icon: employeeIcon,
      title: "Employees",
      link: "/superadmin/employees",
    },
    {
      icon: resetPwdIcon,
      title: "Reset Password",
      link: "/superadmin/reset/password",
    },
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90vw] py-5">
        <h1 className="text-[30px] font-semibold text-center text-slate-700 w-full">
          Superadmin Dashboard
        </h1>
        <div className="w-full mt-10">
          <div className="grid grid-cols-4 gap-[3rem]">
            {optionArray.map((opt, i) => (
              <Link to={opt.link} key={i}>
                <section className="flex justify-center items-center flex-col border w-full p-3 rounded-xl hover:bg-slate-50">
                  <section className="w-[7rem] h-[7rem]">
                    <img
                      src={opt.icon}
                      alt=""
                      className="w-ful h-full object-contain"
                    />
                  </section>
                  <h2 className="mt-3 text-center font-medium text-slate-700">
                    {opt.title}
                  </h2>
                </section>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuperadminDashboard;
